import { render, staticRenderFns } from "./EPGProviderChannels.vue?vue&type=template&id=a3d46692&"
import script from "./EPGProviderChannels.vue?vue&type=script&lang=js&"
export * from "./EPGProviderChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports